import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './concussionAdvice.module.scss';
import { MobileHeader } from '../../components/mobileHeader/mobileHeader';
import completeRest from '../../assets/img/HIT007 C4-ReturnPlay-1-01-1.png';
import dailyActivities from '../../assets/img/HIT007 C4-ReturnPlay-1-02 1.png';
import lightAerobicExercise from '../../assets/img/HIT007 C4-ReturnPlay-1-03 1.png';
import sportSpecificExercise from '../../assets/img/HIT007 C4-ReturnPlay-1-04 1.png';
import nonContractTraining from '../../assets/img/HIT007 C4-ReturnPlay-1-05 1.png';
import returnToFullTraining from '../../assets/img/HIT007 C4-ReturnPlay-1-06 1.png';
import returnToPlay from '../../assets/img/HIT007 C4-ReturnPlay-1-07 1.png';

export function ConcussionReturnToPlayPage() {
  const { t } = useTranslation();

  return (
    <>
      <MobileHeader />
      <div className={styles.container}>
        <div className={styles.heading}>
          {t('resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_TITLE')}
        </div>
        <div className={styles.divider} />
        <div className={styles.content}>
          <div className={styles.step}>
            <div className={styles.stepTitle}>
              {t('resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_HEADER_1')}
            </div>
            <div className={styles.stepDescription}>
              {t(
                'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_DESCRIPTION_1',
              )}
            </div>
            <div className={styles.stepImage}>
              <img
                src={completeRest}
                alt={t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_1',
                ).toString()}
              />
            </div>
            <div className={styles.returnToPlayContent}>
              <div className={styles.title}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_1',
                )}
              </div>
              <div className={styles.description}>
                <ul>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_1_POINT_1',
                    )}
                  </li>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_1_POINT_2',
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.stepImage}>
              <img
                src={dailyActivities}
                alt={t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_2',
                ).toString()}
              />
            </div>
            <div className={styles.returnToPlayContent}>
              <div className={styles.title}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_2',
                )}
              </div>
              <div className={styles.description}>
                <ul>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_2_POINT_1',
                    )}
                  </li>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_2_POINT_2',
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.stepImage}>
              <img
                src={lightAerobicExercise}
                alt={t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_3',
                ).toString()}
              />
            </div>
            <div className={styles.returnToPlayContent}>
              <div className={styles.title}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_3',
                )}
              </div>
              <div className={styles.description}>
                <ul>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_3_POINT_1',
                    )}
                  </li>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_3_POINT_2',
                    )}
                  </li>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_3_POINT_3',
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.stepImage}>
              <img
                src={sportSpecificExercise}
                alt={t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_4',
                ).toString()}
              />
            </div>
            <div className={styles.returnToPlayContent}>
              <div className={styles.title}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_4',
                )}
              </div>
              <div className={styles.description}>
                <ul>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_4_POINT_1',
                    )}
                  </li>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_4_POINT_2',
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.stepImage}>
              <img
                src={nonContractTraining}
                alt={t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_5',
                ).toString()}
              />
            </div>
            <div className={styles.returnToPlayContent}>
              <div className={styles.title}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_5',
                )}
              </div>
              <div className={styles.description}>
                <ul>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_5_POINT_1',
                    )}
                  </li>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_5_POINT_2',
                    )}
                  </li>
                  <li>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_5_POINT_3',
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.stepDescription}>
              {t(
                'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_6',
              )}
              <ul>
                <li>
                  {t(
                    'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_6_POINT_1',
                  )}
                </li>
              </ul>
            </div>
            <div className={styles.stepImage}>
              <img
                src={returnToFullTraining}
                alt={t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_7',
                ).toString()}
              />
            </div>
            <div className={styles.returnToPlayContent}>
              <div className={styles.title}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_7',
                )}
              </div>
              <div className={styles.description}>
                <ul>
                  <li className={styles.stepPoint}>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_7_POINT_1',
                    )}
                  </li>
                  <li className={styles.stepPoint}>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_7_POINT_2',
                    )}
                  </li>
                  <li className={styles.stepPoint}>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_7_POINT_3',
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.stepImage}>
              <img
                src={returnToPlay}
                alt={t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_8',
                ).toString()}
              />
            </div>
            <div className={styles.returnToPlayContent}>
              <div className={styles.title}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_8',
                )}
              </div>
              <div className={styles.description}>
                <ul>
                  <li className={styles.stepPoint}>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_8_POINT_1',
                    )}
                  </li>
                  <li className={styles.stepPoint}>
                    {t(
                      'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_POINTHEADER_8_POINT_2',
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.step}>
              <div className={styles.stepTitle}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_HEADER_2',
                )}
              </div>
              <div className={styles.stepDescription}>
                {t(
                  'resources.concussion.CONCUSSION_RETURN_PLAY_GUIDE_DESCRIPTION_2',
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
